/*eslint-disable*/
import React, { Fragment, useState, useEffect, useContext } from "react";
import Table from "../../components/table/Table";
import api from "../../services/api";
import { formatDateTime } from "../../helpers/helpers";
import pedidoEvento from "../../enums/pedidoEvento";
import AuthContext from "../../auth/context";
import AppContext from "../../container/context";

import { Description, ShoppingCart } from "@mui/icons-material";
import { Button, CircularProgress, Grid } from "@mui/material";

const Fechamento = ({ history }) => {
  const [carregando, setCarregando] = useState(true);
  const [pedidos, setPedidos] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    listar();
  }, []);

  const listar = () => {
    api
      .get("pedidos/listarGerenciamentoEscola")
      .then((pedidos) => {
        pedidos.forEach((p) => {
          p.codigo = p.pedidoId.toString().padStart(5, "0");
          p.pedidoDataHora = formatDateTime(p.pedidoDataHora, "D/M/Y h:m");
          p.pedidoValorTotal = `R$ ${(p.pedidoValorTotal/100).toFixed(2)}`;
          p.ultimoEvento = p.ultimoEvento ? p.ultimoEvento : "Pendente";
        });

        setPedidos(pedidos);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", `Erro: ${e}`);
        setCarregando(false);
      });
  };

  const registrosTabela = montarTabelaCarrinho(pedidos, history);

  return (
    <Fragment>
      <Grid container direction="row" justifyContent="end" alignItems="center">
        <Button
          variant="contained"
          color="primary"
          startIcon={<ShoppingCart />}
          onClick={() => history.push("/app/carrinho")}
        >
          Meu carrinho
        </Button>
      </Grid>
      {carregando ? (
        <CircularProgress />
      ) : (
        <Fragment>
          <div className="main-container">
            {/* <h3>Pedidos</h3> */}
            <Grid container>
              <Grid item md={12}>
                <Table
                  tableHead={[
                    "SITUAÇÃO",
                    "CÓDIGO",
                    "DATA/HORA",
                    "VALOR",
                    "DETALHES",
                  ]}
                  tableData={registrosTabela}
                />
              </Grid>
            </Grid>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Fechamento;

const montarTabelaCarrinho = (pedidos, history) => {
  const registros = [];

  pedidos.forEach((pedido) => {
    registros.push([
      <p>{pedidoEvento.desc(pedido.ultimoEvento)}</p>,
      <p>{pedido.codigo}</p>,
      <p>{pedido.pedidoDataHora}</p>,
      <p>{pedido.pedidoValorTotal}</p>,
      <Button
        title="Ver detalhes"
        round
        justIcon
        size="sm"
        color="primary"
        onClick={() =>
          history.push(`/app/pedidos-escola/pedido/${pedido.pedidoId}`)
        }
      >
        <Description />
      </Button>,
    ]);
  });

  return registros;
};
